import RoomCapacity from './RoomCapacity';

export default RoomCapacity;
